export const makeDefaultFilters = (): URLSearchParams => {
  const defaultFilters = new URLSearchParams();
  ["draft", "active", "paused", "finished"].forEach((status) => {
    if (!defaultFilters.getAll("status").includes(status)) {
      defaultFilters.append("status", status);
    }
  });
  return defaultFilters;
};
